var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('OaoOverlay',{style:({ visibility: _vm.play ? 'visible' : 'hidden' }),attrs:{"isSubmit":""}},[_c('NonMemberLoader',{attrs:{"source":_vm.source,"play":_vm.play}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }